export default {
  findDuplicateIndices(arr) {
    const elementIndices = {}
    const duplicates = {}

    // 遍历数组，记录每个元素的所有下标
    arr.forEach((element, index) => {
      if (!elementIndices[element]) {
        elementIndices[element] = [index]
      } else {
        elementIndices[element].push(index)
      }
    })

    // 从记录的下标中筛选出重复元素及其下标
    for (const [element, indices] of Object.entries(elementIndices)) {
      if (indices.length > 1) {
        duplicates[element] = indices
      }
    }

    return duplicates
  },
  /**
   * @date     : 2025-2-12
   * @direction: 生成多位随机串，仅限于数字和字母
   * @param    :
   * @author   : gaoenhui
   */
  randomString(n) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    let result = ''
    for (let i = 0; i < n; i++) {
      result += '' + characters.charAt(Math.floor(Math.random() * characters.length))
    }
    return result
  }
}



// WEBPACK FOOTER //
// ./src/assets/common/js/common.js